// Canonical feature document registry.
import { featureUserPreferencesDocument } from './user-preferences';
import { featureModeratorToolsDocument } from './moderator-tools';
import { featureLoginDocument } from './login';
import { featurePoppyDocument } from './poppy';
import { featureAudioDocument } from './audio';
import { featureGameRoomLifecycleDocument } from './game-room-lifecycle';
import { featureTwitchDocument } from './twitch';
import { featureLoonsDocument } from './loons';
import { featureAchievementsDocument } from './achievements';
export const featureDocuments = [
    featureUserPreferencesDocument,
    featureModeratorToolsDocument,
    featureLoginDocument,
    featurePoppyDocument,
    featureAudioDocument,
    featureGameRoomLifecycleDocument,
    featureTwitchDocument,
    featureLoonsDocument,
    featureAchievementsDocument,
];
export const featureDocumentsBySlug = Object.fromEntries(featureDocuments.map((document) => [document.slug, document]));
export * from './user-preferences';
export * from './moderator-tools';
export * from './login';
export * from './poppy';
export * from './audio';
export * from './game-room-lifecycle';
export * from './twitch';
export * from './loons';
export * from './achievements';
//# sourceMappingURL=index.js.map